// components/DropdownMenu.tsx
import { Fragment, JSX } from 'react';
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';


interface DropdownProps {
    title: string;
    items: string[];
    icon?: JSX.Element;
    onSelectFunction: (action: string) => void;
}

const DropdownMenu: React.FC<DropdownProps> = ({ title, items, icon = undefined, onSelectFunction }) => {
    return (
        <div className="relative inline-block text-left">
            <Menu as="div" className="inline-block text-left">
                <div onClick={() => onSelectFunction(title)}>
                    <MenuButton className="inline-flex justify-center w-full rounded-md bg-blue-800 px-2 py-0 text-sm font-medium text-white hover:bg-blue-700 focus:outline-none">
                        {icon && icon}
                        {title}
                        {/* <ChevronDownIcon className="ml-2 -mr-1 h-5 w-5" aria-hidden="true" /> */}
                    </MenuButton>
                </div>

                {(items.length > 0) ? (
                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-100"
                        enterFrom="transform opacity-0 scale-95"
                        enterTo="transform opacity-100 scale-100"
                        leave="transition ease-in duration-75"
                        leaveFrom="transform opacity-100 scale-100"
                        leaveTo="transform opacity-0 scale-95"
                    >
                        <MenuItems className="absolute mt-0 w-44 origin-top-left rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none z-10">
                            <div className="py-1">
                                {items.map((item, index) => (
                                    <MenuItem key={index}>
                                        {({ active }) => (
                                            <div
                                                onClick={() => onSelectFunction(item)}
                                                className={`${active ? 'bg-blue-100 text-blue-900' : 'text-gray-900'
                                                    } block px-4 py-2 text-sm`}
                                            >
                                                {item}
                                            </div>
                                        )}
                                    </MenuItem>
                                ))}
                            </div>
                        </MenuItems>
                    </Transition>
                ) : null}
            </Menu>
        </div>
    );
};

export default DropdownMenu;
